import { render, staticRenderFns } from "./ContractsView.vue?vue&type=template&id=7a84e948"
import script from "./ContractsView.vue?vue&type=script&lang=ts"
export * from "./ContractsView.vue?vue&type=script&lang=ts"
import style0 from "./ContractsView.vue?vue&type=style&index=0&id=7a84e948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports